import { apiRequest } from "./client"

export interface OrderItemRequest { sifra: string; kolicina: number; napomena?: string }
export interface SubmitOrderRequest { stavke: OrderItemRequest[]; nacinPlacanja: number; napomena?: string }
export interface SubmitOrderResponse {
  success: boolean
  poruka: string
  fiskalniRedId: number
  status: string
  ukupnoIznos: number
  kreiranoUtc: string
}
export interface FiscalStatus {
  fiskalniRedId: number
  status: "NA_CEKANJU" | "U_OBRADI" | "FISKALIZOVANO" | "GRESKA"
  brd?: number
  fiskRn?: number
  greska?: string
  brojPokusaja: number
  kreiranoUtc: string
  fiskalizovanoUtc?: string
  trajanjeMs: number
}
export interface ActiveOrderItem {
  artikal: string
  kolicina: number
  monitor?: number
  aktivno: boolean
  datumVrijeme: string
  datumVrijemeZ?: string
  napomena?: string
}
export interface ActiveOrder {
  brojNarudzbe: number
  datumVrijeme: string
  brojAktivnih: number
  brojZavrsenih: number
  ukupnoStavki: number
  stavke: ActiveOrderItem[]
}

export async function submitOrder(token: string, deviceUuid: string, idempotencyKey: string, request: SubmitOrderRequest): Promise<SubmitOrderResponse> {
  return apiRequest("/orders/submit", { method: "POST", token, deviceUuid, idempotencyKey, body: request })
}

export async function getFiscalStatus(token: string, deviceUuid: string, fiskalniRedId: number): Promise<FiscalStatus> {
  return apiRequest(`/orders/${fiskalniRedId}/status`, { token, deviceUuid })
}

export async function getActiveOrders(token: string, deviceUuid: string): Promise<ActiveOrder[]> {
  return apiRequest("/orders/active", { token, deviceUuid })
}
